import Model, { attr, belongsTo, hasMany } from "@ember-data/model";
import { tKey } from "ember-intl";
import { task } from "ember-concurrency";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class RemoteHandsRequestModel extends Model {
  @attr key;
  @attr datacenter;
  @attr status;
  @attr executionoption;
  @attr instructions;
  @attr servicekeys;
  @attr createdat;
  @attr trackingids;
  @attr shipmentkeys;
  @attr title;

  @hasMany("shipment", { async: false, inverse: "remoteHandsRequest" }) shipments;
  @belongsTo("project", { async: false, inverse: "remoteHandsRequests" }) project;

  get isPending() {
    return this.status?.toUpperCase() === "PENDING";
  }

  get isInProgress() {
    return this.status?.toUpperCase() === "IN_PROGRESS";
  }

  get isCompleted() {
    return this.status?.toUpperCase() === "COMPLETED";
  }

  get isCanceled() {
    return this.status?.toUpperCase() === "CANCELED";
  }

  get isCancelable() {
    return (
      this.isPending &&
      this.shipments.filter((shipment) => !shipment.isCanceled).every((shipment) => shipment.isCancelable)
    );
  }

  get isNotCancelable() {
    return !this.isCancelable;
  }

  get executionOptionLabelKey() {
    switch (this.executionoption?.toUpperCase()) {
      case "ASAP":
        return tKey("remote-hands-requests.execution-options.ASAP");
      case "SCHEDULED":
        return tKey("remote-hands-requests.execution-options.SCHEDULED");
      default:
        return tKey("remote-hands-requests.execution-options.UNKNOWN");
    }
  }

  get workflowState() {
    switch (this.status?.toUpperCase()) {
      case "PENDING":
        return { color: "gray", labelKey: tKey("remote-hands-requests.statuses.PENDING") };
      case "IN_PROGRESS":
        return { color: "blue", labelKey: tKey("remote-hands-requests.statuses.IN_PROGRESS") };
      case "COMPLETED":
        return { color: "green", labelKey: tKey("remote-hands-requests.statuses.COMPLETED") };
      case "CANCELED":
        return { color: "red", labelKey: tKey("remote-hands-requests.statuses.CANCELED") };
      default:
        return { color: "gray", labelKey: tKey("remote-hands-requests.statuses.UNKNOWN") };
    }
  }

  cancelTask = task(async () => {
    try {
      this.status = "CANCELED";

      await this.store.request(saveRecord(this));
    } catch (error) {
      this.rollbackAttributes();

      throw error;
    }
  });
}
